import PropTypes from "prop-types"
import React from "react"
import { Redirect, Route } from "react-router-dom"
import { Grid } from "semantic-ui-react"
import TabNavSubNavigation from "./TabNavSubNavigation"

const TabNavSection = ({ children, ...rest }) => (
  <Route
    path={"/" + rest.name}
    render={({ location }) => {
      return (
        <TabNavSectionContainer
          {...rest}
          tabNavChildren={children}
          location={location}
        />
      )
    }}
  />
)

TabNavSection.displayName = "TabNavSection"

TabNavSection.propTypes = {
  showIntroduction: PropTypes.func,
  name: PropTypes.string,
  title: PropTypes.string,
  skip: PropTypes.func
}

TabNavSection.defaultProps = {
  showIntroduction: () => Promise.resolve(false),
  skip: () => false
}

class TabNavSectionContainer extends React.Component {
  componentDidMount = async () => {
    try {
      await this.props.onEnter()
    } catch (error) {
      // TODO
    }
  }
  componentWillUnmount = async () => {
    try {
      await this.props.onExit()
    } catch (error) {
      // TODO
    }
  }
  render = () => {
    const {
      showIntroduction,
      location,
      name,
      title,
      tabNavChildren: children
    } = this.props
    const Introduction = React.Children.toArray(children).find(
      child => child && child.type.displayName === "TabNavIntroduction"
    )
    const subNavigations = React.Children.toArray(children)
      .filter(child => child && child.type.displayName === "TabNavSubSection")
      .filter(child => !child.props.skip())
      .map(child => React.cloneElement(child, { section: name }))
    const hasSubSectionNav = path =>
      subNavigations
        .map(subNavigation => `/${name}/${subNavigation.props.name}`)
        .indexOf(path) >= 0
    const currentSubsection = subNavigations.find(
      subsection => subsection.props.name === location.pathname.split("/")[2]
    )
    const explicitlyHideSubnavigation =
      currentSubsection && currentSubsection.props.hideSubnavigation
    const subNavigationVisibility =
      currentSubsection && currentSubsection.props.subNavigationVisibility
    return (
      <Grid style={{ marginTop: "0" }}>
        {subNavigationVisibility === undefined ? (
          hasSubSectionNav(location.pathname) &&
          !explicitlyHideSubnavigation ? (
            <TabNavSubNavigation
              section={{ name, title }}
              subsections={subNavigations
                .filter(subsection => !subsection.props.skip())
                .map(subsection => ({
                  // Should we avoid this 'map' and pass the children instead?
                  name: subsection.props.name,
                  title: subsection.props.title,
                  disabled: Boolean(subsection.props.disabled)
                }))}
            />
          ) : null
        ) : subNavigationVisibility === "true" ? (
          <TabNavSubNavigation
            section={{ name, title }}
            subsections={subNavigations
              .filter(subsection => !subsection.props.skip())
              .map(subsection => ({
                // Should we avoid this 'map' and pass the children instead?
                name: subsection.props.name,
                title: subsection.props.title,
                disabled: Boolean(subsection.props.disabled)
              }))}
          />
        ) : null}
        <Grid.Row>
          <Grid.Column>
            <Route
              path={"/" + name + "/introduction"}
              render={() => Introduction}
            />
            <Route
              exact
              path={"/" + name}
              render={() => (
                <div>
                  {showIntroduction() ? (
                    <Redirect to={"/" + name + "/introduction"} />
                  ) : (
                    <Redirect
                      to={"/" + name + "/" + subNavigations[0].props.name}
                    />
                  )}
                </div>
              )}
            />
            {subNavigations}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

TabNavSectionContainer.propTypes = {
  onEnter: PropTypes.func,
  onExit: PropTypes.func
}

TabNavSectionContainer.defaultProps = {
  onEnter: () => {},
  onExit: () => {}
}
export default TabNavSection
